export const camelToLower = (state: string) => {
    return state.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase()
}
